import { type SidebarSection, useMenu } from '@core-ui/components';
import { SettingsHeader } from '@moniebook-web/components/molecules/settings-header';
import { itemIsSideLink } from '@moniebook-web/components/widgets/sidebar';
import { ArrowLeftLine } from '@moniebook-web/icons/arrows/arrow-left-line';
import { useFeatureFlagStore } from '@moniebook-web/store';
import { PAGES, SETTINGS_SECTIONS } from '@moniebook-web/types';
import clsx from 'clsx';
import { NavLink } from 'react-router';

const SECTIONS: Array<SidebarSection> = [
    {
        id: SETTINGS_SECTIONS.SETTINGS,
        name: 'Settings',
    },
    {
        id: SETTINGS_SECTIONS.BUSINESS,
        name: 'Business',
    },
    {
        id: SETTINGS_SECTIONS.SALES,
        name: 'Sales',
    },
    {
        id: SETTINGS_SECTIONS.INVENTORY,
        name: 'Inventory',
    },
    {
        id: SETTINGS_SECTIONS.ACCOUNTING,
        name: 'Accounting',
    },
] as const;

export function SettingsSidebar() {
    const { featureFlags } = useFeatureFlagStore();
    const sections = useMenu(SECTIONS, featureFlags ?? {}, true);

    return (
        <nav className='settings-sidebar'>
            <div className='settings-sidebar-content'>
                <div className='settings-sidebar-mobile-header'>
                    <SettingsHeader title='Settings' />
                    <BackToHome />
                </div>
                <div className='overflow-y-auto pb-40'>
                    <BackToHome key='back-to-home' />
                    {sections.map((section) => {
                        return (
                            <section
                                className='settings-sidebar-section'
                                key={section.name}>
                                <h4 className='settings-sidebar-header'>
                                    {section.name}
                                </h4>
                                <div className='flex flex-col'>
                                    {section.menu.map(
                                        (link) =>
                                            itemIsSideLink(link) && (
                                                <NavLink
                                                    to={link.to}
                                                    className={({ isActive }) =>
                                                        clsx(
                                                            'settings-sidebar-link',
                                                            {
                                                                active: isActive,
                                                            },
                                                        )
                                                    }
                                                    key={link.name}>
                                                    {link.name}
                                                </NavLink>
                                            ),
                                    )}
                                </div>
                            </section>
                        );
                    })}
                </div>
            </div>
        </nav>
    );
}

function BackToHome() {
    return (
        <section className='settings-sidebar-section'>
            <NavLink to={PAGES.HOME} className='settings-sidebar-back-link'>
                <ArrowLeftLine /> Back to homepage
            </NavLink>
        </section>
    );
}
